import React from 'react'

import { Field } from 'react-form'

import { Editor } from 'primereact/editor'

import FieldMessage from './FieldMessage'

import { validateFromRule, getRuleForField } from '../../js/validation'

import '../../css/field.css'

// this ia wrapper function for the prime react editor so it can work with react-form's form object
// make sure it is used with Form tags
// this allows the value of the form to read and updated in the form

// the reason this is done is because prime react's components are examples of controlled components
// they have a value set that binds to the state or props so that when that state or props is udated the component is re-rendered
// the onChange of the component needs to be handled to update the value of the state or props otherwise the user input will not be picked up
// use react-form's setValue function will update the state of the field on the form so that changes will be reflected

// pass in the field as the property name to bind and the label as what is displayed
// showAsTextOnly is used to disable the component, hide the component styling and make it look like text only
/*
  <Form>
  {formApi => {
    return (
      <div className=""p-grid">
        <div className="p-col-12">
            <FieldEditor field={"Position"} label={"Position"} validationRules={validationRules} showAsTextOnly={showAsTextOnly}/>
        </div>
      </div>
    )}
  }
  </Form>
*/
class FieldEditor extends React.Component {
  render() {
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
    }
    return (
      // Use the form field and your custom input together to create your very own input!
      // field is the property name that is bound to in the form
      // validate is a function used to validate the field
      <Field field={this.props.field} validate={this.validate}>
        {fieldApi => {
          // fieldApi properties can found at https://react-form.js.org/#/custom-input
          // Remember to pull off everything you dont want ending up on the element otherwise it will throw errors
          // this extracts things out of the props passed in and leaves ...rest to be the rest of the properties
          // this way can pass in the extra properties to the prime react component
          const { onBlur, onChange, validate, field, editorRef, validationRules, showAsTextOnly, inputStyle, ...rest } = this.props
          // value and setValue read and update value in the form
          const { value, setValue, setTouched, error, warning, success } = fieldApi
          return (
            <div className="p-grid">
              <div className="p-col-12 field-label-container">
                <label>
                  {this.props.label}
                  {validationRule && validationRule.IsRequired === false && <span className="optional-field"> - Optional</span>}
                </label>
              </div>
              <div className="p-col-12 field-element-container">
                <Editor {...rest} value={value || ''}
                  ref={editorRef}
                  style={inputStyle}
                  className={showAsTextOnly ? 'show-text-only' : ''}
                  disabled={showAsTextOnly || rest.disabled}
                  onTextChange={e => {
                    if (onChange) { onChange(e) }
                    setValue(e.htmlValue)
                  }}
                  onBlur={e => {
                    setTouched()
                    if (onBlur) {
                      onBlur(e)
                    }
                  }}
                />
              </div>
              {(error || warning || success) && <div className="p-col-12">
                {error ? <FieldMessage color="#B30000" message={error} /> : null}
                {!error && warning ? <FieldMessage color="orange" message={warning} /> : null}
                {!error && !warning && success ? <FieldMessage color="green" message={success} /> : null}
              </div>}
            </div>
          )
        }}
      </Field>
    )
  }

  /*
    generic validation handler for input field
    checks the validation rules
    TODO - optional validation passed in as a props
  */
  validate = value => {
    let validationResult = {}
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
      if (validationRule) {
        validationResult = validateFromRule(validationRule, value)
      }
    } else {
      validationResult.success = ''
    }
    return validationResult
  }
}

export default FieldEditor;



// WEBPACK FOOTER //
// ./src/components/common/FieldEditor.js